/*
 * @author Anatoliy Gladkikh <a.gladkikh@autotrade.su>
 */

import $          from "jquery";
import loader_gif from "../../images/preloader.gif";
import Inputmask  from "inputmask";

export class Open_lines {
  constructor() {
    this.block = $('.block-send-message-open-lines');
    Inputmask({"mask": "+7 (999) 999-9999"}).mask($('.block-send-message-open-lines input[type="tel"]'));

    this.block
      .on('click', '[data-submit-form-open-lines]', this.sendMessage.bind(this))
    ;
  }

  sendMessage(e) {
    const preloader = $('[data-preloader]');
    let $form = $(e.currentTarget).closest('form');
    let name = $('[name="name"]', $form);
    let tel = $('[name="tel"]', $form);
    let email = $('[name="email"]', $form);
    let nameValue = $.trim(name.val());
    let telValue = $.trim(tel.val());
    let emailValue = $.trim(email.val());

    if (nameValue === '' || nameValue === '-') {
      this._validateField(name, false, 'required');
      return;
    }
    const regexName = RegExp('^[а-яa-z\\s\\-]{1,30}$', 'ui');
    if (false === regexName.test(nameValue)) {
      this._validateField(name, false, 'pattern');
      return;
    } else {
      this._validateField(name, true, 'pattern');
    }

    if (telValue === '') {
      this._validateField(tel, false, 'required');
      return;
    }
    if (tel[0].inputmask) {
      if (!tel[0].inputmask.isComplete()) {
        this._validateField(tel, false, 'pattern');
        return;
      } else {
        this._validateField(tel, true, 'pattern');
      }
    }

    if ('' !== emailValue) {
      const regexEmail = RegExp('(.*@.*)', 'ui');
      if (false === regexEmail.test(emailValue)) {
        this._validateField(email, false, 'pattern');
        return;
      } else {
        this._validateField(email, true, 'pattern');
      }
    } else {
      this._validateField(email, true, 'pattern');
    }

    if (!grecaptcha.getResponse()) {
      alert('Вы не заполнили поле Я не робот!');
      grecaptcha.reset();
    } else {
      $.ajax({
        url: '/q/send_message_to_ol',
        method: 'POST',
        data: $form.serializeArray(),
        beforeSend: () => {
          preloader.html('<img src="' + loader_gif + '" width="25" alt="Подождите" /> Подождите ...');
          $(e.currentTarget).addClass('disabled');
          this.block.find('.alert').hide();
        }
      }).then((data) => {
        preloader.html('');
        $(e.currentTarget).removeClass('disabled');
        if ('success' === data.result) {
          $form.hide();
          this.block.find('.alert').hide();
          this.block.find('.success').show();
        } else {
          grecaptcha.reset();
          this.block.find('.alert').html(data.info).show();
        }
      }).catch((error) => {
        grecaptcha.reset();
        preloader.html('');
        $(e.currentTarget).removeClass('disabled');
        this.block.find('.alert').html(error).show();
      });
    }
  }

  _validateField($el, isValid, type) {
    let label = $el.closest('label');
    let blockError = label.find('.form-error[data-form-error-on="' + type + '"]');

    label.find('.form-error').removeClass('is-visible');

    if (isValid) {
      // valid
      $el.removeClass('is-invalid-input');
      label.removeClass('is-invalid-label');
      blockError.removeClass('is-visible');
    } else {
      // invalid
      $el.addClass('is-invalid-input');
      label.addClass('is-invalid-label');
      blockError.addClass('is-visible');
    }
  }
}